import React from "react";
import { useParams } from "react-router-dom";
import "./audit-committee.css";

import Template from "./Template/Template";
import TemplateDetail from "./Template/TemplateDetail";

export default function AuditCommittee() {
  const { id } = useParams();

  return (
    <>
      <div className="audit-header">
        <h2 className="audit-title">감사위원회</h2>
      </div>

      {id ? <TemplateDetail /> : <Template />}
    </>
  );
}